import React from 'react';
import classNames from 'classnames';
import styles from './PremiumAnswerPlaceholder.module.scss';
import {
  ButtonAppearance,
  ButtonSize,
  IconPosition,
} from '../../../../components/ButtonBase/types';
import Button from '../../../../components/Button/Button';
import { Phrases } from '../../../../utilities/constants/phrases';
import { IconGlyph } from '../../../../components/Icon';
import { useOpenSubscriptionPopup } from '../../../../hooks/popup/useOpenSubscriptionPopup';

interface Props {
  title?: string;
}

const PremiumAnswerPlaceholder: React.FC<Props> = ({ title }) => {
  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();

  return (
    <>
      {title && (
        <div className={styles.container}>
          <p className={classNames('text-md fw-bold', styles.title)}>{title}</p>
        </div>
      )}
      <div className='pos-r'>
        <div className={styles.overlay}>
          <div className={classNames(styles.buttonContainer, 'ta-center')}>
            <Button
              appearance={ButtonAppearance.PRIMARY_GRADIENT}
              size={ButtonSize.MEDIUM}
              className={styles.closeButton}
              icon={{
                position: IconPosition.LEFT,
                glyph: IconGlyph.UNLOCK,
              }}
              onClick={handleOpenSubscriptionPopup}>
              {Phrases.PREMIUM_ANSWER_PLACEHOLDER_UNLOCK_BUTTON_LABEL}
            </Button>
          </div>
        </div>
        <div className={styles.container}>
          <p className='mt-xs mb-xxs'>
            {Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_1}
          </p>
          <p className='mb-xxs text-md fw-bold'>
            {Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_2}
          </p>
          <p className='mb-xxs'>{Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_3}</p>
          <p className='mb-xxs text-md fw-bold'>
            {Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_4}
          </p>
          <ul className='mb-xxs'>
            <li>{Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_5}</li>
            <li>{Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_6}</li>
            <li>{Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_7}</li>
          </ul>
          <p className='mb-xxs text-md fw-bold'>
            {Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_8}
          </p>
          <p className='mb-xl'>{Phrases.PREMIUM_ANSWER_PLACEHOLDER_TEXT_9}</p>
        </div>
      </div>
    </>
  );
};

export default PremiumAnswerPlaceholder;
